var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 400,
    height: 309.33334,
    viewBox: "0 0 758.66669 309.33334",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,309.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1341.46,1451.13 H 792.313 v -98.8 H 1306.81 V 1198.37 H 792.313 V 944.324 H 637.066 v 660.766 h 704.394 v -153.96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2199.83,1149.61 c 0,-55.6 -17.53,-103.5 -52.6,-143.7 -35.07,-40.203 -79.98,-60.301 -134.73,-60.301 h -436.23 c -55.6,0 -100.72,20.098 -135.36,60.301 -34.64,40.2 -51.96,88.1 -51.96,143.7 v 455.48 h 153.96 v -455.48 c 0,-33.36 11.12,-50.04 33.36,-50.04 h 436.23 c 21.39,0 32.08,16.68 32.08,50.04 v 455.48 h 155.25 v -455.48",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3051.79,1148.33 c 0,-55.6 -16.68,-103.08 -50.04,-142.42 -35.93,-41.058 -81.26,-61.586 -136,-61.586 h -569.68 v 153.966 h 569.68 c 21.38,0 32.07,16.67 32.07,50.04 0,33.35 -10.69,50.04 -32.07,50.04 h -414.43 c -54.74,0 -100.07,20.52 -136,61.58 -34.21,38.49 -51.32,85.54 -51.32,141.14 0,55.59 17.54,103.5 52.61,143.7 35.06,40.2 79.97,60.3 134.71,60.3 h 569.67 v -153.96 h -569.67 c -21.38,0 -32.07,-16.68 -32.07,-50.04 0,-32.51 10.69,-48.76 32.07,-48.76 h 414.43 c 54.74,0 100.07,-20.53 136,-61.59 33.36,-39.34 50.04,-86.81 50.04,-142.41",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3115.96,1453.13 v 151.97 h 153.97 v -151.97 h -153.97",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3269.93,944.324 H 3115.96 V 1408.6 h 153.97 V 944.324",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4152.66,1153.46 c 0,-59.87 -20.96,-109.7 -62.87,-149.48 -41.92,-39.769 -92.81,-59.656 -152.68,-59.656 h -387.48 c -59.88,0 -110.77,19.887 -152.68,59.656 -41.92,39.78 -62.88,89.61 -62.88,149.48 v 242.49 c 0,59.88 20.96,109.7 62.88,149.48 41.91,39.77 92.8,59.66 152.68,59.66 h 387.48 c 59.87,0 110.76,-19.89 152.68,-59.66 41.91,-39.78 62.87,-89.6 62.87,-149.48 z m -153.97,0 v 242.49 c 0,36.78 -20.53,55.18 -61.58,55.18 h -387.48 c -41.06,0 -61.59,-18.4 -61.59,-55.18 v -242.49 c 0,-36.78 20.53,-55.17 61.59,-55.17 h 387.48 c 41.05,0 61.58,18.39 61.58,55.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4921.22,944.324 H 4767.26 L 4370.8,1389.54 V 944.324 h -153.97 v 660.766 h 153.97 l 396.46,-441.37 v 441.37 h 153.96 V 944.324",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 915.129,779.25 859.082,660.707 c -4.098,-8.711 -10.82,-13.043 -20.172,-13.043 -8.828,0 -15.191,4.137 -19.09,12.371 l -40.929,87.27 -42.164,-87.508 c -3.504,-7.402 -9.829,-11.063 -19.016,-11.063 -9.785,0 -16.469,3.864 -20.051,11.657 L 641.855,779.25 c -0.996,2.105 -1.511,4.094 -1.511,6.043 0,4.059 1.945,7.398 5.847,10.023 3.618,2.508 7.832,3.743 12.567,3.743 7.398,0 12.41,-2.746 15.035,-8.278 l 43.797,-93 41.488,89.024 c 3.981,8.633 10.504,12.929 19.61,12.929 3.46,0 7.121,-1.195 10.941,-3.621 3.82,-2.386 6.445,-5.211 7.914,-8.39 l 42.207,-89.981 43.117,92.801 c 2.547,5.609 7.797,8.395 15.715,8.395 4.813,0 8.988,-1.114 12.488,-3.383 3.778,-2.543 5.688,-5.809 5.688,-9.785 0,-2.11 -0.516,-4.293 -1.629,-6.52",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1048.88,661.305 c 0,-9.028 -4.5,-13.524 -13.53,-13.524 -7.2,0 -12.01,0.438 -14.32,1.274 -4.49,1.789 -6.76,5.886 -6.76,12.25 v 123.629 c 0,6.367 2.3,10.464 6.88,12.254 2.19,0.835 6.92,1.273 14.2,1.273 9.03,0 13.53,-4.496 13.53,-13.527 V 661.305",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1330.95,667.391 c 0,-13.68 -6.16,-20.524 -18.54,-20.524 -1.11,0 -2.22,0.039 -3.37,0.117 -3.99,0.399 -8.72,2.946 -14.25,7.637 l -113.6,96.621 v -89.937 c 0,-6.364 -2.31,-10.461 -6.89,-12.25 -2.3,-0.836 -7.12,-1.274 -14.32,-1.274 -8.94,0 -13.4,4.496 -13.4,13.524 v 118.422 c 0,4.812 0.4,8.152 1.15,10.019 1.2,2.707 3.7,5.215 7.6,7.442 2.71,1.55 5.65,2.347 8.83,2.347 6.76,0 13.49,-2.824 20.17,-8.515 l 112.01,-95.426 v 89.34 c 0,6.406 2.31,10.464 6.89,12.254 2.22,0.875 7,1.273 14.2,1.273 9.02,0 13.52,-4.496 13.52,-13.527 V 667.391",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1614.38,690.422 c 0,-7.356 -1.47,-13.402 -4.42,-18.176 h -0.12 c -4.65,-8.594 -13.56,-15.117 -26.69,-19.453 -10.02,-3.34 -20.52,-5.012 -31.46,-5.012 h -109.55 c -8.95,0 -13.41,4.496 -13.41,13.524 v 123.629 c 0,9.031 4.46,13.527 13.41,13.527 h 110.11 c 41.41,0 62.13,-13.527 62.13,-40.535 z m -34.49,0.121 v 67.266 c 0,7.121 -9.43,10.699 -28.32,10.699 h -88.23 v -90.774 h 87.75 c 19.21,0 28.8,4.258 28.8,12.809",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1892.48,690.184 c 0,-16.071 -8.23,-27.684 -24.7,-34.844 -11.82,-5.051 -26.97,-7.559 -45.47,-7.559 h -40.29 c -17.87,0 -32.86,2.625 -44.99,7.914 -16.63,7.243 -24.94,18.7 -24.94,34.371 v 65.512 c 0,16.231 8.15,27.965 24.46,35.203 11.73,5.133 26.89,7.68 45.47,7.68 h 40.29 c 20.84,0 36.4,-2.188 46.74,-6.523 15.63,-6.524 23.43,-18.657 23.43,-36.36 z m -34.61,0.597 v 64.203 c 0,9.028 -11.66,13.524 -34.96,13.524 h -41.02 c -10.58,0 -17.74,-0.356 -21.44,-1.035 -9.18,-1.871 -13.76,-6.047 -13.76,-12.489 v -64.203 c 0,-8.711 11.74,-13.047 35.2,-13.047 h 41.14 c 10.93,0 18.02,0.321 21.2,0.914 9.11,1.711 13.64,5.77 13.64,12.133",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2242.66,779.25 -56.05,-118.543 c -4.1,-8.711 -10.82,-13.043 -20.17,-13.043 -8.83,0 -15.19,4.137 -19.09,12.371 l -40.93,87.27 -42.17,-87.508 c -3.5,-7.402 -9.82,-11.063 -19.01,-11.063 -9.79,0 -16.47,3.864 -20.05,11.657 l -55.81,118.859 c -0.99,2.105 -1.51,4.094 -1.51,6.043 0,4.059 1.95,7.398 5.85,10.023 3.62,2.508 7.83,3.743 12.57,3.743 7.4,0 12.41,-2.746 15.03,-8.278 l 43.8,-93 41.49,89.024 c 3.98,8.633 10.5,12.929 19.6,12.929 3.47,0 7.13,-1.195 10.95,-3.621 3.82,-2.386 6.44,-5.211 7.91,-8.39 l 42.21,-89.981 43.12,92.801 c 2.54,5.609 7.79,8.395 15.71,8.395 4.81,0 8.99,-1.114 12.49,-3.383 3.78,-2.543 5.69,-5.809 5.69,-9.785 0,-2.11 -0.52,-4.293 -1.63,-6.52",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2510.21,687.281 c 0,-8.312 -1.42,-14.957 -4.21,-19.929 -7.36,-13.047 -28.12,-19.571 -62.21,-19.571 h -89.63 c -8.95,0 -13.4,4.496 -13.4,13.524 0,10.941 4.45,16.429 13.4,16.429 h 89.63 c 10.85,0 17.02,0.121 18.49,0.36 8.87,0.996 13.29,3.898 13.29,8.711 v 12.25 c 0,4.656 -5.73,7.679 -17.23,9.07 -4.57,0.477 -13.4,0.715 -26.45,0.715 h -0.95 c -27.73,0 -47.62,1.633 -59.67,4.89 -20.57,5.614 -30.87,16.75 -30.87,33.458 v 10.699 c 0,18.738 9.71,30.91 29.12,36.476 9.35,2.746 26.37,4.098 51.07,4.098 9,0 13.49,-4.496 13.49,-13.527 v -2.782 c 0,-9.109 -4.49,-13.644 -13.49,-13.644 -14.71,0 -23.27,-0.117 -25.77,-0.356 -13.13,-1.238 -19.69,-4.578 -19.69,-10.027 v -9.863 c 0,-5.93 11.45,-8.871 34.37,-8.871 h 34.61 c 16.18,0 30.19,-2.543 42.08,-7.68 15.99,-6.918 24.02,-17.5 24.02,-31.699 v -12.731",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2882.89,667.152 c 0.4,-1.789 0.6,-3.539 0.6,-5.25 0,-5.132 -1.63,-9.226 -4.93,-12.293 -3.3,-3.058 -7.24,-4.613 -11.85,-4.613 -6.49,0 -11.74,2.867 -15.72,8.633 l -21.56,31.586 h -104.57 l -21.64,-31.586 c -3.34,-4.895 -7.4,-7.359 -12.13,-7.359 -4.1,0 -7.88,1.671 -11.26,4.972 -3.38,3.301 -5.06,6.645 -5.06,10.063 0,1.472 0.41,2.785 1.16,3.98 l 81.82,125.141 c 3.9,5.887 10.3,9.07 19.21,9.547 3.43,0.16 7.09,-0.598 10.99,-2.227 4.49,-1.914 7.11,-4.418 7.91,-7.441 z m -74.74,48.133 -30.99,45.824 -31.18,-45.824 z",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3165.77,667.391 c 0,-13.68 -6.17,-20.524 -18.54,-20.524 -1.11,0 -2.23,0.039 -3.38,0.117 -3.98,0.399 -8.71,2.946 -14.24,7.637 L 3016,751.242 v -89.937 c 0,-6.364 -2.3,-10.461 -6.88,-12.25 -2.31,-0.836 -7.12,-1.274 -14.32,-1.274 -8.95,0 -13.41,4.496 -13.41,13.524 v 118.422 c 0,4.812 0.4,8.152 1.16,10.019 1.19,2.707 3.7,5.215 7.6,7.442 2.7,1.55 5.65,2.347 8.83,2.347 6.76,0 13.48,-2.824 20.16,-8.515 l 112.02,-95.426 v 89.34 c 0,6.406 2.31,10.464 6.88,12.254 2.23,0.875 7,1.273 14.2,1.273 9.03,0 13.53,-4.496 13.53,-13.527 V 667.391",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3449.2,690.422 c 0,-7.356 -1.47,-13.402 -4.42,-18.176 h -0.12 c -4.65,-8.594 -13.56,-15.117 -26.69,-19.453 -10.02,-3.34 -20.52,-5.012 -31.46,-5.012 h -109.55 c -8.95,0 -13.41,4.496 -13.41,13.524 v 123.629 c 0,9.031 4.46,13.527 13.41,13.527 h 110.1 c 41.41,0 62.14,-13.527 62.14,-40.535 z m -34.49,0.121 v 67.266 c 0,7.121 -9.43,10.699 -28.32,10.699 h -88.23 v -90.774 h 87.75 c 19.21,0 28.8,4.258 28.8,12.809",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3821.8,690.422 c 0,-7.356 -1.48,-13.402 -4.42,-18.176 h -0.12 c -4.65,-8.594 -13.56,-15.117 -26.69,-19.453 -10.02,-3.34 -20.53,-5.012 -31.46,-5.012 h -109.55 c -8.95,0 -13.41,4.496 -13.41,13.524 v 123.629 c 0,9.031 4.46,13.527 13.41,13.527 h 110.1 c 41.41,0 62.14,-13.527 62.14,-40.535 z m -34.49,0.121 v 67.266 c 0,7.121 -9.43,10.699 -28.32,10.699 h -88.23 v -90.774 h 87.75 c 19.21,0 28.8,4.258 28.8,12.809",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4099.89,690.184 c 0,-16.071 -8.23,-27.684 -24.7,-34.844 -11.81,-5.051 -26.97,-7.559 -45.46,-7.559 h -40.3 c -17.86,0 -32.86,2.625 -44.99,7.914 -16.62,7.243 -24.94,18.7 -24.94,34.371 v 65.512 c 0,16.231 8.16,27.965 24.46,35.203 11.74,5.133 26.9,7.68 45.47,7.68 h 40.3 c 20.84,0 36.4,-2.188 46.73,-6.523 15.64,-6.524 23.43,-18.657 23.43,-36.36 z m -34.6,0.597 v 64.203 c 0,9.028 -11.66,13.524 -34.97,13.524 h -41.01 c -10.58,0 -17.74,-0.356 -21.44,-1.035 -9.19,-1.871 -13.76,-6.047 -13.76,-12.489 v -64.203 c 0,-8.711 11.73,-13.047 35.2,-13.047 h 41.13 c 10.94,0 18.02,0.321 21.2,0.914 9.11,1.711 13.65,5.77 13.65,12.133",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4378.11,690.184 c 0,-16.071 -8.23,-27.684 -24.7,-34.844 -11.81,-5.051 -26.97,-7.559 -45.46,-7.559 h -40.3 c -17.86,0 -32.86,2.625 -44.99,7.914 -16.62,7.243 -24.94,18.7 -24.94,34.371 v 65.512 c 0,16.231 8.16,27.965 24.46,35.203 11.74,5.133 26.89,7.68 45.47,7.68 h 40.3 c 20.84,0 36.39,-2.188 46.73,-6.523 15.64,-6.524 23.43,-18.657 23.43,-36.36 z m -34.6,0.597 v 64.203 c 0,9.028 -11.66,13.524 -34.97,13.524 h -41.01 c -10.58,0 -17.74,-0.356 -21.44,-1.035 -9.19,-1.871 -13.76,-6.047 -13.76,-12.489 v -64.203 c 0,-8.711 11.73,-13.047 35.2,-13.047 h 41.13 c 10.94,0 18.02,0.321 21.2,0.914 9.11,1.711 13.65,5.77 13.65,12.133",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4659.95,741.02 c 0,-14 -7.24,-24.422 -21.68,-31.266 -11.01,-5.207 -24.34,-7.793 -39.98,-7.793 h -21.08 l 66.67,-28.203 c 6.37,-2.707 9.55,-7.082 9.55,-13.051 0,-3.418 -1.23,-6.324 -3.74,-8.75 -2.71,-2.625 -6.37,-4.016 -10.94,-4.176 -18.26,-0.636 -42.44,6.168 -72.52,20.407 -18.53,9.546 -37.11,19.05 -55.68,28.558 v -35.441 c 0,-9.028 -4.5,-13.524 -13.53,-13.524 -7.2,0 -11.97,0.438 -14.2,1.274 -4.57,1.789 -6.88,5.886 -6.88,12.25 v 123.629 c 0,9.031 4.45,13.527 13.4,13.527 h 104.18 c 16.95,0 31.19,-2.504 42.77,-7.559 15.78,-6.922 23.66,-17.859 23.66,-32.777 z m -34.61,-0.239 v 17.942 c 0,5.132 -4.29,8.273 -12.92,9.429 -1.87,0.239 -8.2,0.356 -19.02,0.356 h -82.85 V 731.91 h 87.51 c 7.95,0 13.32,0.242 16.23,0.719 7.35,1.152 11.05,3.855 11.05,8.152",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4926.16,687.281 c 0,-8.312 -1.43,-14.957 -4.22,-19.929 -7.36,-13.047 -28.12,-19.571 -62.21,-19.571 h -89.62 c -8.95,0 -13.41,4.496 -13.41,13.524 0,10.941 4.46,16.429 13.41,16.429 h 89.62 c 10.86,0 17.02,0.121 18.5,0.36 8.86,0.996 13.28,3.898 13.28,8.711 v 12.25 c 0,4.656 -5.73,7.679 -17.22,9.07 -4.58,0.477 -13.41,0.715 -26.45,0.715 h -0.96 c -27.72,0 -47.61,1.633 -59.67,4.89 -20.56,5.614 -30.86,16.75 -30.86,33.458 v 10.699 c 0,18.738 9.7,30.91 29.11,36.476 9.35,2.746 26.38,4.098 51.08,4.098 8.99,0 13.48,-4.496 13.48,-13.527 v -2.782 c 0,-9.109 -4.49,-13.644 -13.48,-13.644 -14.72,0 -23.27,-0.117 -25.78,-0.356 -13.12,-1.238 -19.69,-4.578 -19.69,-10.027 v -9.863 c 0,-5.93 11.46,-8.871 34.37,-8.871 h 34.61 c 16.18,0 30.19,-2.543 42.08,-7.68 15.99,-6.918 24.03,-17.5 24.03,-31.699 v -12.731",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3618.35,1284.86 v 108.17 h 109.59 v -108.17 h -109.59",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3760.71,1284.86 v 108.17 h 109.59 v -108.17 h -109.59",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3618.35,1144.31 v 108.17 h 109.59 v -108.17 h -109.59",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3760.71,1144.31 v 108.17 h 109.59 v -108.17 h -109.59",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.746ae0e8a1e5342207d164c26075698f.svg";
export { ForwardRef as ReactComponent };